import React from 'react';
import { noop } from 'lodash';
import classNames from 'classnames';
import { bool, func } from 'prop-types';
import { ChevronLeftIcon, ChevronRightIcon } from '@fiverr-private/icons';
import { grey_900 } from '@fiverr-private/sass/helpers';

import classes from './style.module.scss';

const CarouselNavigation = ({
    canScrollLeft = false,
    canScrollRight = false,
    onScrollLeft = noop,
    onScrollRight = noop
}) => (
    <>
        {canScrollLeft && (
            <button className={classNames(classes.navigationArrow, classes.leftArrow)}
                onClick={onScrollLeft}>
                <ChevronLeftIcon color={grey_900}/>
            </button>
        )}
        {canScrollRight && (
            <button className={classNames(classes.navigationArrow, classes.rightArrow)}
                onClick={onScrollRight}>
                <ChevronRightIcon color={grey_900}/>
            </button>
        )}
    </>
);

CarouselNavigation.propTypes = {
    canScrollLeft: bool,
    canScrollRight: bool,
    onScrollLeft: func,
    onScrollRight: func
};

export default CarouselNavigation;
